import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import * as React from 'react';
export default {
  StepVerifyErrorTracking,
  React
};